import { makeGetRequest } from 'owa-ows-gateway';
import { DomainConnectFetchSetupResponse } from 'owa-domain-connect';

const fetchAndValidatePremiumDomainUrl: string = 'ows/api/v1/PremiumDomain/fetchandvalidate';

export async function fetchAndValidateDomain(): Promise<DomainConnectFetchSetupResponse> {
    let response = await makeGetRequest(fetchAndValidatePremiumDomainUrl);
    return response;
}
